export const getCookie = (name) => {
    // For auth tokens and data, prioritize localStorage to bypass 4KB cookie limits
    if (['adminToken', 'adminAuth', 'adminRefreshToken', 'adminGlobalToken', 'adminGlobalRefreshToken'].includes(name)) {
        const lsValue = localStorage.getItem(name);
        if (lsValue) return lsValue;
    }
    
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
};

export const setCookie = (name, value, days = 7) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    const secureParam = window.location.protocol === 'https:' ? "; secure" : "";
    document.cookie = `${name}=${encodeURIComponent(value || "")}${expires}; path=/; samesite=strict${secureParam}`;
    
    // Also save to localStorage to bypass 4KB cookie size limit
    if (value) {
        localStorage.setItem(name, value);
    } else {
        localStorage.removeItem(name);
    }
};

export const deleteCookie = (name) => {
    const secureParam = window.location.protocol === 'https:' ? "; secure" : "";
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; samesite=strict${secureParam}`;
    localStorage.removeItem(name);
};
